export enum RouteViewType {
    New = 1,
    Details,
    Edit,
    Delete,
    Manage,
    Summary
}
